import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import company logos
import michaelPageLogo from "../assets/michael-page-logo.webp";
import mockupImage from "../assets/mockup.webp";
import rushLogo from "../assets/rush-logo.webp";
import dodLogo from "../assets/dod-logo.webp";
import stalwartLogo from "../assets/stalwart-films-logo.webp";
import taylorLogo from "../assets/taylor-logo.webp";

interface ArrowProps {
  onClick?: () => void;
}

const TrustedByCarousel: React.FC = () => {
  // Reordered logos to match desktop display: michael page, mockup, rush university, dod-logo, stalwart films
  const logos = [
    { src: michaelPageLogo, alt: "Michael Page Logo" },
    { src: mockupImage, alt: "PPE Mockup" },
    { src: rushLogo, alt: "Rush University Logo" },
    { src: dodLogo, alt: "Department of Defense Logo" },
    { src: stalwartLogo, alt: "Stalwart Films Logo" },
    { src: taylorLogo, alt: "Taylor Farms Logo" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  // Custom arrow components
  const CustomPrevArrow: React.FC<ArrowProps> = ({ onClick }) => {
    return (
      <button
        className="bg-transparent p-0 absolute -left-20 top-1/2 transform -translate-y-1/2 z-10 text-[#3a3a3c] transition-colors duration-200 hidden md:block focus:outline-none"
        onClick={onClick}
        aria-label="Previous"
      >
        <svg
          className="w-[30px] h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
            color="#3a3a3c"
          />
        </svg>
      </button>
    );
  };

  const CustomNextArrow: React.FC<ArrowProps> = ({ onClick }) => {
    return (
      <button
        className="bg-transparent p-0 absolute -right-20 top-1/2 transform -translate-y-1/2 z-10 text-[#3a3a3c] transition-colors duration-200 hidden md:block focus:outline-none"
        onClick={onClick}
        aria-label="Next"
      >
        <svg
          className="w-[30px] h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
            color="#3a3a3c"
          />
        </svg>
      </button>
    );
  };

  return (
    <div className="w-full pt-8 pb-[26px] bg-white">
      <div className="max-w-[1710px] mx-auto px-[20px]">
        <h4 className="text-2xl md:text-[23px] font-bold text-center text-[#303030] mb-5 uppercase">
          Trusted By
        </h4>

        <div className="relative md:px-[80px] py-2.5">
          <Slider
            {...settings}
            prevArrow={<CustomPrevArrow />}
            nextArrow={<CustomNextArrow />}
          >
            {logos.map((logo, index) => (
              <div key={index} className="px-4">
                <div className="h-[104px] flex items-center justify-center">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-full max-h-full object-contain filter transition-all duration-300"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default TrustedByCarousel;
